import { LicenseInfo, muiXTelemetrySettings } from '@mui/x-license';

/** MUI X の有償コンポーネントを使う前に一度だけ呼ぶ */
export const setupMuiX = (licenseKey: string): void => {
  LicenseInfo.setLicenseKey(licenseKey);
  // v9 から開発時（NODE_ENV !== 'production'）は telemetry を既定で送るようになった（v8 は既定で送らない）。
  // 送信内容にライセンスキーそのものと端末のフィンガープリントが含まれるため止める。
  // 環境変数 MUI_X_TELEMETRY_DISABLED は process.env 経由でしか読まれず vite のブラウザ側では効かないので、コードで止める。
  muiXTelemetrySettings.disableTelemetry();
};
